import { Directive, ViewContainerRef } from '@angular/core';

/**
 * Container directive or control errors
 */
@Directive({
  selector: '[controlErrorContainer]'
 })
 export class ControlErrorContainerDirective {
  constructor(public vcr: ViewContainerRef) { }
 }
